var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"min-width":"320px"}},[_vm._t("default"),_c('ChatBot')],2)}
var staticRenderFns = []

export { render, staticRenderFns }